export default theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: '200px',
    width: '200px',
  }
});
